import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import React, { useContext } from "react"

const LoadingProgress = () => {
  const loadingContext = useContext(GlobalLoaderContext)
  // return loadingContext.loading ? <LinearProgress /> : null;
  return <></>
}
export default LoadingProgress
